import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

// Página 404 — para URLs não-mapeadas (link antigo, typo). Sem isso, o SPA renderizava conteúdo em branco.
export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-4 py-16 text-center">
        <div className="text-5xl">🔍</div>
        <h1 className="mt-3 text-2xl font-bold text-text">Página não encontrada</h1>
        <p className="mt-2 text-gray-600">O endereço que você acessou não existe ou foi movido.</p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="rounded-xl bg-primary hover:opacity-90 text-white font-semibold px-5 py-2.5">Ir para o início</Link>
          <Link to="/empresas" className="rounded-xl border border-primary text-primary font-semibold px-5 py-2.5 hover:bg-primary hover:text-white transition">Ver empresas</Link>
        </div>
      </main>
    </div>
  );
}
